import { $t } from "@/plugins/vue-i18n";

export function required(value) {
  return !!value || $t("validation.required");
}

export function sameAs(value, referenceValue) {
  return value === referenceValue ? true : $t("validation.sameAs");
}
